import{jsx as t}from"react/jsx-runtime";import{ModalTitle as o}from"@vds-core/modals";const r=function(r){return t(o,Object.assign({},r,{padding:"0px"}))};export{r as default};
